// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v3.31.0-0-g1df4de4",
    "hash": "g1df4de4",
    "distance": 0,
    "tag": "v3.31.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v3.31.0",
        "major": 3,
        "minor": 31,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "3.31.0"
    },
    "suffix": "0-g1df4de4",
    "semverString": "3.31.0",
    "version": "3.31.0"
};
/* tslint:enable */
